import { FC } from "react";

import CustomLink from "@Components/CustomLink";
import AmberConnectIcon from "@Icons/AmberConnectIcon";
import AmberFlexIcon from "@Icons/AmberFlexIcon";
import AmberRedIcon from "@Icons/AmberRedIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import { COMPONENTS_CATEGORY, EVENT_LABEL, PAGE } from "constants/index";
import gtagEventEmitter from "helpers/gtagEventEmitter";

import supportStyles from "../Support/SupportMenu.module.scss";
import styles from "./ProductsMenu.module.scss";

type Props = { onClose: () => void };

const trackProductLink = (action: string) => {
  gtagEventEmitter({
    action,
    category: COMPONENTS_CATEGORY.TOP_NAV,
    label: `${PAGE.SEARCH} `,
  });
};

/**
 * The old header's Products dropdown (ProductsDropdown) — Dashboard, then Amber Flex and
 * Amber Connect —
 * in the Support menu's card, opened from the bar's "Products" pill.
 * Shown to internal users, as the old one was; the links point where its rows did.
 */
const ProductsMenu: FC<Props> = ({ onClose }) => (
  <div
    className={`${supportStyles.menu} ${styles.menu}`}
    role="menu"
    data-testid="v3-products-menu"
  >
    <CustomLink href="/dashboard" className={supportStyles.row} onClick={onClose}>
      <span className={styles.mark} aria-hidden="true">
        <AmberRedIcon />
      </span>
      Dashboard
    </CustomLink>
    <hr className={supportStyles.rule} />
    <CustomLink
      href="/partner"
      className={supportStyles.row}
      onClick={() => {
        trackProductLink(EVENT_LABEL.AMBER_FLEX_CLICKED);
        onClose();
      }}
    >
      <span className={styles.mark} aria-hidden="true">
        <AmberFlexIcon />
      </span>
      Amber Flex
    </CustomLink>
    <CustomLink
      href="/connect"
      className={supportStyles.row}
      onClick={() => {
        trackProductLink(EVENT_LABEL.AMBER_CONNECT_CLICKED);
        onClose();
      }}
    >
      <span className={styles.mark} aria-hidden="true">
        <AmberConnectIcon />
      </span>
      Amber Connect
    </CustomLink>
  </div>
);

// China as the old ProductsDropdown; not on whitelabel, as the rest of this header.
export default wrapperHOC(ProductsMenu, {
  componentName: "HomeV3-ProductsMenu",
  showForChina: true,
  showForWhiteLable: false,
});
